import { formatosDefault } from '@/core/constants'

const opcoesDateTime =  {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour:'numeric',
    minute:'numeric',
    second:'numeric'
}
export default {
    methods: {
        humanizarFormatoDataHora() {
            return formatosDefault.DATA_HORA_MINUTO
        },
        humanizarFormatoData() {
            return formatosDefault.DATA
        },
        humanizarFormatoHora() {
            return formatosDefault.HORA
        },
        // assume que a data recebida esta no timezone America/Sao_Paulo
        ehFuturo(data) {
            return this.moment(data).isAfter(agora(this))
        },
        // assume que a data recebida esta no timezone America/Sao_Paulo
        ehPresenteOuPassado(data) {
            return this.moment(data).isSameOrBefore(agora(this))
        },
        hoje(opcoes){
            return (new Date()).toLocaleDateString('pt-br', {...opcoesDateTime, ...opcoes}).trim()
        },
        dataHoje(opcoes){
            return (new Date()).toLocaleDateString('pt-br', {...opcoesDateTime, ...opcoes}).split(',')[0].trim()
        },
        horaAgora(opcoes){
            return (new Date()).toLocaleDateString('pt-br', {...opcoesDateTime, ...opcoes}).split(',')[1].trim()
        }
    }
}

function agora(self) {
    return self.moment().tz(self.$store.state.loki.timezone)
}
